export const CertificationQualiopi = [
  'ActionFormation',
  'BilanCompetence',
  'Vae',
  'ActionFormationApprentissage',
] as const

export type CertificationQualiopi = typeof CertificationQualiopi[number]

export const CertificationQualiopiLibelle: {
  [key in CertificationQualiopi]: string
} = {
  ActionFormation: 'Certification Action Formation',
  BilanCompetence: 'Certification Bilan compétence',
  Vae: 'Certification VAE',
  ActionFormationApprentissage: 'Certification Action Formation apprentissage',
} as const

